import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { TypeActivite, CreateTypeActiviteRequest, UpdateTypeActiviteRequest } from '@/shared/types/admin'

export const typesActiviteApi = {
  getAll: () =>
    api.get<ApiResponse<TypeActivite[]>>('/api/types-activite').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<TypeActivite>>(`/api/types-activite/${id}`).then((r) => r.data.data),

  getActifs: () =>
    api.get<ApiResponse<TypeActivite[]>>('/api/types-activite/actifs').then((r) => r.data.data),

  create: (data: CreateTypeActiviteRequest) =>
    api.post<ApiResponse<TypeActivite>>('/api/types-activite', data).then((r) => r.data.data),

  update: (id: number, data: UpdateTypeActiviteRequest) =>
    api.put<ApiResponse<TypeActivite>>(`/api/types-activite/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/types-activite/${id}`),
}
